export default __webpack_public_path__ + "static/media/chain-19.74ea0692.png";